import { FareProductAPI } from '../../../api/datamanager/FareProductAPI';

export class FareProductsCommand {
    getAll(provider, successCallback, errorCallback) {
        const apiResult = FareProductAPI.list(provider);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(provider, model, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(0 === model.id) {
            apiResult = FareProductAPI.create(model, provider);
            successMessage = "Produto criado com sucesso";
        }
        else {
            apiResult = FareProductAPI.update(model.id, model);
            successMessage = "Produto editado com sucesso";
        }
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback(successMessage);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(provider, modelId, successCallback, errorCallback) {
        const apiResult = FareProductAPI.delete(modelId, provider);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Produto eliminado com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
